var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoButtonGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-button"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6771 11.677C9.64608 13.7077 6.35354 13.7076 4.32274 11.6771L3.7571 12.2426L4.32262 11.677C2.29238 9.64594 2.29221 6.35368 4.32259 4.32271L4.32265 4.32265L4.32271 4.32259C6.35369 2.29219 9.6462 2.29241 11.677 4.32259L11.677 4.32265L11.6771 4.32271C13.7076 6.35382 13.7077 9.64633 11.6771 11.677ZM3.75696 12.2427C1.4143 9.89927 1.41404 6.1004 3.75696 3.75696C6.1004 1.41404 9.89953 1.4143 12.2427 3.75696C14.5856 6.1004 14.5859 9.89953 12.2427 12.2427C9.89927 14.5859 6.10014 14.5856 3.75696 12.2427ZM8.75585 10.5728C8.76524 10.1786 8.46471 9.85928 8.01392 9.85928C7.54434 9.85928 7.24407 10.1786 7.24381 10.5728C7.25346 10.9857 7.5446 11.2957 8.00478 11.2957C8.46471 11.2957 8.76524 10.986 8.75585 10.5728ZM8.00009 4.60838C7.56782 4.60838 7.21746 4.95873 7.21746 5.391V8.52151C7.21746 8.95378 7.56782 9.30413 8.00009 9.30413C8.43236 9.30413 8.78271 8.95378 8.78271 8.52151V5.391C8.78271 4.95873 8.43236 4.60838 8.00009 4.60838Z",
    fill: "#566985"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoButtonGrey);
export default __webpack_public_path__ + "static/media/info-button-grey.a8438c7827b1829fc4424a506dbbb05a.svg";
export { ForwardRef as ReactComponent };